import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ReadNotificationsMutationVariables = Types.Exact<{
  input: Types.ReadNotificationsInput;
}>;


export type ReadNotificationsMutation = { readNotifications: { success?: boolean | null } };


export const ReadNotificationsDocument = /*#__PURE__*/ gql`
    mutation readNotifications($input: ReadNotificationsInput!) {
  readNotifications(input: $input) {
    success
  }
}
    `;

export function useReadNotificationsMutation() {
  return Urql.useMutation<ReadNotificationsMutation, ReadNotificationsMutationVariables>(ReadNotificationsDocument);
};